import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'

import { AnalyticsEventAddToCart } from '../analytics/events/recommended'
import { processProductModalSignals, productModalStateMethods } from './modal/state'
import { OpenProductModalInput, ProductModalData, ProductModalState } from './modal/types'

// modal state

export type QuickViewProductModalData = ProductModalData & {
  analyticsEventAppContext?: 'plp' | 'related_products' | 'featured_products'
}
export type QuickViewProductModalState = ProductModalState<QuickViewProductModalData>
const quickViewProductModalState = productModalStateMethods<QuickViewProductModalData>()
const [quickViewProductModalState$, setQuickViewProductModalState] =
  createSignal<QuickViewProductModalState>()
const [useQuickViewProductModalState] = bind<QuickViewProductModalState>(
  quickViewProductModalState$,
  quickViewProductModalState.closed(),
)
export { useQuickViewProductModalState }

// open modal

export type OpenQuickViewProductModalInput = OpenProductModalInput & {
  analyticsEventAppContext?: AnalyticsEventAddToCart['app_context']
}
const [openQuickViewProductModal$, openQuickViewProductModal] =
  createSignal<OpenQuickViewProductModalInput>()
export { openQuickViewProductModal }

// close modal

const [closeQuickViewProductModal$, closeQuickViewProductModal] = createSignal<void>()
export { closeQuickViewProductModal }

// process signals

const { open$, close$ } = processProductModalSignals({
  productModalState: quickViewProductModalState,
  openProductModal$: openQuickViewProductModal$,
  closeProductModal$: closeQuickViewProductModal$,
  setProductModalState: setQuickViewProductModalState,
})

open$.subscribe()
close$.subscribe()
